export default "__VITE_ASSET__BuCYozTN__"